import React from 'react';
import { RadioGroup } from 'blueprint-form';

const SelectMethod = ({
  isMessageOnly,
  isCallOnly,
  isSurvey
}: {
  isMessageOnly?: boolean;
  isCallOnly?: boolean;
  isSurvey?: boolean;
}): JSX.Element => {
  const options: any[] = [];
  if (!isCallOnly) {
    options.push({
      label: 'Text Message',
      value: 'message'
    });
  }
  if (!isMessageOnly) {
    options.push({
      label: 'Phone Call',
      value: 'call'
    });
  }
  return (
    <RadioGroup
      label="Communication Method"
      name={isSurvey ? 'type' : 'method'}
      options={options}
      inline
    />
  );
};

export default SelectMethod;
